import { SET_ENHANCED_MODAL_OPEN } from '../actions/EnhancedModalActions';

const initialState = {
  open: false,
};

const enhancedModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ENHANCED_MODAL_OPEN:
      return {
        open: action.payload.flag,
      };

    default:
      return state;
  }
};

export default enhancedModalReducer;
